// extracted by mini-css-extract-plugin
export var characterActive = "styles-module--character-active--irGbG";
export var characterBack = "styles-module--character-back--w6HHD";
export var characterContainer = "styles-module--character-container--d1YZD";
export var characterImg = "styles-module--character-img--tINw0";
export var characterInactive = "styles-module--character-inactive--+PRAJ";
export var characterRight = "styles-module--character-right--Noetx";
export var characterTitle = "styles-module--character-title--7oepe";